const OrderLifeCycleState = {
  active: "ACTIVE",
  activing: "ACTIVING",
  creating: "CREATING",
  deleted: "DELETED",
  hold: "HOLD",
  pendingActivation: "PENDING_ACTIVATION",
}

export default OrderLifeCycleState;